import { Injectable } from '@angular/core';
import { Command, StateService, CommandInterfaces } from 'flux-core';
import { DataStore } from 'flux-store';
import { ModelSubscriptionManager } from 'flux-subscription';
import { AbstractMessageCommand } from 'flux-connection';
import { Observable, from } from 'rxjs';
import { ProjectModel } from 'flux-diagram/models';

/**
 * This is the command to unarchive a project, The project can be unarchived by it's owner only
 */
@Injectable()
@Command()
export class UnarchiveProject extends AbstractMessageCommand {

    public static get implements(): Array<CommandInterfaces> {
        return [
            'IMessageCommand',
            'IProjectCommand',
        ];
    }

    constructor(
            protected dataStore: DataStore,
            protected modelSubManager: ModelSubscriptionManager,
            protected state: StateService<any, any> ) {
                super() /* istanbul ignore next */;
    }

    public execute(): any {
        return true;
    }

    public executeResult( response: any ): boolean | Observable<any> {
        const projectModelStore = this.dataStore.getModelStore( ProjectModel );
        const affectedProjectIds = Array.isArray( response?.affectedProjectIds ) && response.affectedProjectIds.length
            ? response.affectedProjectIds
            : [ this.resourceId ];
        return from( projectModelStore.updateStatic(
            { id: { $in: affectedProjectIds }},
            { $set: { archived: false }},
        ));
    }
}

Object.defineProperty( UnarchiveProject, 'name', {
    value: 'UnarchiveProject',
});
